import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-date-lang-format-dialog',
  templateUrl: './date-lang-format-dialog.component.html',
  styleUrl: './date-lang-format-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DateLangFormatDialogComponent {}
